<!-- 🌟 Manager Actions -->
<div class="container py-4">
  <div class="row row-cols-1 row-cols-sm-1 g-3 text-center text-md-start">
    <div class="col">
      <button class="btn btn-gradient w-100" (click)="downloadEmployeesJson()">
        <i class="bi bi-download me-2"></i>
        Download All Employees as JSON
      </button>
    </div>

    <div class="col">
      <button
        class="btn btn-gradient w-100 d-flex align-items-center justify-content-center"
        (click)="goToManageEmployees()"
      >
        <i class="bi bi-people me-2"></i>
        Manage Employees
      </button>
    </div>

    <div class="col">
      <button
        class="btn btn-gradient w-100 position-relative"
        data-bs-toggle="modal"
        data-bs-target="#viewRequestsModal"
        (click)="loadRequestsOff()"
      >
        <i class="bi bi-calendar-check me-2"></i>View Requests Off
        <span
          *ngIf="pendingCount > 0"
          class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
        >
          {{ pendingCount }}
          <span class="visually-hidden">pending requests</span>
        </span>
      </button>
    </div>

    <div class="col">
      <button
        class="btn btn-gradient w-100 d-flex align-items-center justify-content-center"
        (click)="goToSwapShifts()"
      >
        <i class="bi bi-arrow-left-right me-2"></i>
        Approve Shift Swaps
      </button>
    </div>

    <div class="col">
      <button
        class="btn btn-gradient w-100 d-flex align-items-center justify-content-center"
        (click)="goToCreateSchedule()"
      >
        <i class="bi bi-table me-2"></i>Create New Schedule
      </button>
    </div>

    <div class="col">
      <button
        class="btn btn-gradient w-100 d-flex align-items-center justify-content-center"
        (click)="goToManageTimesheets()"
      >
        <i class="bi bi-clock-history me-2"></i>Manage Timesheets
      </button>
    </div>

    <div class="col">
      <button
        class="btn btn-gradient w-100 d-flex align-items-center justify-content-center"
        (click)="goToPublicSchedule()"
      >
        <i class="bi bi-calendar-event me-2"></i> Published Schedules
      </button>
    </div>
  </div>
</div>

<!-- 📅 Upload Schedule Modal -->
<div
  class="modal fade"
  id="uploadScheduleModal"
  tabindex="-1"
  aria-labelledby="uploadScheduleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <form
        [formGroup]="uploadScheduleForm"
        (ngSubmit)="onUploadScheduleSubmit()"
      >
        <div class="modal-header bg-success text-white">
          <h5 class="modal-title" id="uploadScheduleModalLabel">
            <i class="bi bi-calendar-week me-2"></i>Upload Weekly Schedule
          </h5>
          <button
            type="button"
            class="btn-close btn-close-white"
            data-bs-dismiss="modal"
          ></button>
        </div>

        <div class="modal-body">
          <!-- Week Start Date -->
          <div class="mb-3">
            <label class="form-label fw-semibold">
              <i class="bi bi-calendar-event me-2 text-primary"></i>Week Start
              Date <span class="text-danger">*</span>
            </label>
            <input
              type="date"
              class="form-control"
              formControlName="weekStartDate"
              required
            />
          </div>

          <!-- Title -->
          <div class="mb-3">
            <label class="form-label fw-semibold">
              <i class="bi bi-tag me-2 text-primary"></i>Schedule Title
              (Optional)
            </label>
            <input
              type="text"
              class="form-control"
              formControlName="title"
              placeholder="e.g., Holiday Week, Regular Schedule"
            />
          </div>

          <!-- PDF Upload -->
          <div class="mb-3">
            <label class="form-label fw-semibold">
              <i class="bi bi-file-earmark-pdf me-2 text-danger"></i>Schedule
              PDF
              <span class="text-danger">*</span>
            </label>
            <input
              type="file"
              class="form-control"
              accept=".pdf,.png"
              (change)="onFileSelected($event)"
              required
            />
          </div>

          <div
            *ngIf="selectedFile"
            class="alert alert-info d-flex align-items-center"
          >
            <i class="bi bi-file-earmark-pdf-fill fs-3 me-3 text-danger"></i>
            <div>
              <strong>{{ selectedFile.name }}</strong>
              <div class="small text-muted">
                {{ (selectedFile.size / 1024).toFixed(2) }} KB
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-success"
            [disabled]="
              isUploadingSchedule || uploadScheduleForm.invalid || !selectedFile
            "
          >
            <span *ngIf="!isUploadingSchedule">
              <i class="bi bi-upload me-2"></i>Upload Schedule
            </span>
            <span *ngIf="isUploadingSchedule">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Uploading...
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- 📆 View Requests Off Modal -->

<div
  class="modal fade"
  id="viewRequestsModal"
  tabindex="-1"
  aria-labelledby="viewRequestsModalLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable"
  >
    <div class="modal-content">
      <div class="modal-header bg-linear-gradient-purple text-white">
        <h5 class="modal-title" id="viewRequestsModalLabel">
          <i class="bi bi-calendar-check me-2"></i>Time-Off Requests
        </h5>
        <button
          type="button"
          class="btn-close btn-close-white"
          data-bs-dismiss="modal"
        ></button>
      </div>

      <div class="modal-body">
        <!-- 🔽 Filters Accordion -->
        <div class="accordion mb-3" id="filtersAccordion">
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingFilters">
              <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseFilters"
                aria-expanded="true"
                aria-controls="collapseFilters"
              >
                <i class="bi bi-funnel me-2"></i>
                <strong>Filters & Sort Options</strong>
                <span class="badge bg-primary ms-2"
                  >{{ requestsCount }} total</span
                >
              </button>
            </h2>
            <div
              id="collapseFilters"
              class="accordion-collapse collapse show"
              aria-labelledby="headingFilters"
              data-bs-parent="#filtersAccordion"
            >
              <div class="accordion-body">
                <div class="row g-3">
                  <!-- Filter by Status -->
                  <div class="col-md-3">
                    <label class="form-label fw-semibold small">
                      <i class="bi bi-filter me-1"></i>Filter by Status
                    </label>
                    <select
                      class="form-select form-select-sm"
                      [(ngModel)]="filterStatus"
                      (change)="onFilterChange()"
                    >
                      <option value="all">All</option>
                      <option value="pending">Pending</option>
                      <option value="approved">Approved</option>
                      <option value="declined">Declined</option>
                    </select>
                  </div>

                  <!-- Items per page - SMALLER -->
                  <div class="col-md-2">
                    <label class="form-label fw-semibold small">
                      <i class="bi bi-list-ol me-1"></i>Per page
                    </label>
                    <select
                      class="form-select form-select-sm"
                      [(ngModel)]="pageSize"
                      (change)="onPageSizeChange()"
                    >
                      <option [value]="5">5</option>
                      <option [value]="10">10</option>
                      <option [value]="20">20</option>
                      <option [value]="50">50</option>
                    </select>
                  </div>

                  <!-- Sort Options -->
                  <div class="col-md-4">
                    <label class="form-label fw-semibold small">
                      <i class="bi bi-sort-down me-1"></i>Sort By
                    </label>
                    <div class="btn-group btn-group-sm w-100" role="group">
                      <button
                        class="btn btn-outline-secondary"
                        [class.active]="sortBy === 'createdAt'"
                        (click)="onSortChange('createdAt')"
                      >
                        <i class="bi bi-clock-history me-1"></i> Submission Date
                      </button>
                      <button
                        class="btn btn-outline-secondary"
                        [class.active]="sortBy === 'date'"
                        (click)="onSortChange('date')"
                      >
                        <i class="bi bi-calendar-event me-1"></i> Requested Date
                      </button>
                    </div>
                  </div>

                  <!-- Delete All Inactive Button - SAME ROW -->
                  <div class="col-md-3" *ngIf="hasInactiveRequests()">
                    <label class="form-label fw-semibold small">
                      <i class="bi bi-hourglass-split me-1"></i>Delete Expired
                      Requests
                    </label>

                    <div class="btn-group btn-group-sm w-100" role="group">
                      <button
                        class="btn btn-outline-danger"
                        (click)="removeAllInactiveRequests()"
                        [disabled]="isDeletingInactive"
                        title="Remove all requests with dates older than 2 weeks"
                      >
                        <span *ngIf="!isDeletingInactive">
                          <i class="bi bi-trash me-1"></i>
                          Remove All
                          <span
                            class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-dark"
                          >
                            {{ getInactiveRequestsCount() }}
                          </span>
                        </span>
                        <span *ngIf="isDeletingInactive">
                          <span
                            class="spinner-border spinner-border-sm me-2"
                          ></span>
                          Removing...
                        </span>
                      </button>
                    </div>
                  </div>
                  <!-- Delete All Denied Button - SAME ROW -->
                  <div class="col-md-3" *ngIf="hasDeniedRequests()">
                    <label class="form-label fw-semibold small">
                      <i class="bi bi-hourglass-split me-1"></i>Delete Denied
                      Requests
                    </label>

                    <div class="btn-group btn-group-sm w-100" role="group">
                      <button
                        class="btn btn-outline-danger"
                        (click)="removeAllDeniedRequests()"
                        [disabled]="isDeletingDeclined"
                        title="Remove all requests with dates older than 2 weeks"
                      >
                        <span *ngIf="!isDeletingDeclined">
                          <i class="bi bi-trash me-1"></i>
                          Remove All
                          <span
                            class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-dark"
                          >
                            {{ getDeniedRequestsCount() }}
                          </span>
                        </span>
                        <span *ngIf="isDeletingDeclined">
                          <span
                            class="spinner-border spinner-border-sm me-2"
                          ></span>
                          Removing...
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 🧾 Request Cards -->
        <div *ngIf="requestsOff.length; else noRequests">
          <div class="row row-cols-1 row-cols-md-3 row-cols-lg-4 g-3">
            <div class="col" *ngFor="let req of requestsOff">
              <div class="request-card">
                <!-- Employee Name & Type -->
                <div
                  class="d-flex justify-content-between align-items-start mb-2"
                >
                  <div>
                    <h6 class="mb-0 fw-bold">{{ req.employee }}</h6>
                  </div>
                  <span
                    class="badge"
                    [ngClass]="{
                      'bg-warning text-dark': req.status === 'pending',
                      'bg-success': req.status === 'approved',
                      'bg-danger': req.status === 'declined',
                    }"
                  >
                    {{ req.status | titlecase }}
                  </span>
                </div>

                <!-- Date Requested -->
                <div class="mb-2">
                  <div class="text-dark fw-semibold mb-1">
                    <i class="bi bi-calendar-event me-1 text-primary"></i>
                    {{ req.date | date: "MMM d, y" }} Requested Off
                  </div>
                  <small class="text-muted">
                    <i class="bi bi-clock me-1"></i>
                    Submitted On {{ req.createdAt | date: "short" }}
                  </small>
                </div>

                <!-- Inactive Badge -->
                <div
                  *ngIf="isInactiveRequest(req)"
                  class="mb-2 d-flex flex-wrap gap-2"
                >
                  <span class="badge bg-secondary">
                    <i class="bi bi-hourglass-split me-1"></i>Inactive (2+
                    weeks)
                  </span>
                  <span
                    class="badge bg-danger text-white"
                    role="button"
                    (click)="removeInactiveRequest(req)"
                  >
                    <i class="bi bi-trash me-1"></i>Remove Request
                  </span>
                </div>

                <!-- Approved By -->
                <div *ngIf="req.approvedBy" class="mb-2">
                  <small class="text-muted">
                    <i class="bi bi-person-check me-1"></i>
                    By {{ req.approvedBy }}
                  </small>
                </div>

                <!-- Action Buttons -->
                <div class="d-flex gap-2 mt-3">
                  <button
                    class="btn btn-sm btn-success flex-fill"
                    (click)="updateRequestStatus(req, 'approved')"
                    [disabled]="req.status === 'approved'"
                  >
                    <i class="bi bi-check-circle me-1"></i>
                    Approve
                  </button>
                  <button
                    class="btn btn-sm btn-danger flex-fill"
                    (click)="updateRequestStatus(req, 'declined')"
                    [disabled]="req.status === 'declined'"
                  >
                    <i class="bi bi-x-circle me-1"></i>
                    Decline
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Pagination -->
        <div
          class="d-flex flex-column flex-md-row align-items-center justify-content-between gap-2 mt-3"
        >
          <small class="text-muted text-nowrap text-center text-md-start">
            <span *ngIf="currentPage > 0">
              Page {{ currentPage }} of {{ totalPages || 1 }}
            </span>
            <span class="mx-1">•</span>
            {{ requestsCount }} total
            <span *ngIf="filterStatus !== 'all'" class="text-capitalize">
              ({{ filterStatus }})
            </span>
          </small>

          <div class="btn-group pagination-touch" role="group">
            <button
              class="btn btn-outline-secondary pagination-btn"
              (click)="loadRequestsOff('prev')"
              [disabled]="isPrevDisabled"
              title="Previous page"
            >
              <i class="bi bi-chevron-left me-1"></i>
              Prev
            </button>
            <button
              class="btn btn-outline-secondary pagination-btn"
              (click)="loadRequestsOff('next')"
              [disabled]="isNextDisabled"
              title="Next page"
            >
              Next
              <i class="bi bi-chevron-right ms-1"></i>
            </button>
          </div>
        </div>

        <!-- 💤 Empty State -->
        <ng-template #noRequests>
          <div class="text-center text-muted py-5">
            <i class="bi bi-inbox display-4 opacity-25"></i>
            <p class="mt-3 mb-0">Loading time-off requests</p>
          </div>
        </ng-template>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<!-- 🔔 Custom Toast -->
<div class="custom-toast" *ngIf="toastVisible" [ngClass]="toastType">
  {{ toastMessage }}
</div>
